import {OwlDateTimeIntl} from 'ng-pick-datetime';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable({providedIn: 'root'})
export class DefaultIntl extends OwlDateTimeIntl {
  cancelBtnLabel = this.translates.instant('Cancel');
  setBtnLabel = this.translates.instant('Apply');
  rangeFromLabel = this.translates.instant('From');
  rangeToLabel = this.translates.instant('To');

  constructor(
    protected translates: TranslateService,
  ) {
    super();
  }
}
